// The App Store apps (iPhone, iPad and Mac: apple/) run this same web build
// inside a WKWebView, served from the app bundle over the oss:// scheme. The
// app is bought once on the App Store with everything in it, so inside it:
//   - the whole Qmax game is unlocked, with no prices or unlock panels
//   - there are no purchase or donation links (Apple's rule 3.1.1): no Mac
//     screensaver, support/Ko-fi, VR or Vision Pro links, no Stripe buttons
//   - no accounts, cloud saves, sign-up invitations or Remind me buttons
//     (saves stay on the device), no Google Analytics and no bot check, so
//     the App Privacy label can say "Data Not Collected"
//   - no WebXR buttons (WKWebView has none)
// Everywhere else the website behaves exactly as before.
//
// ?app=ios or ?app=mac forces app mode in a browser, for checking it.

const params = (() => {
  try { return new URLSearchParams(location.search); } catch { return new URLSearchParams(''); }
})();

// The Meta Quest app (docs/quest-store.md): the Horizon Store's packaged PWA
// opens /viewer/?app=quest. It is the website in VR, not the App Store
// shell, so it is its own mode: IS_APP stays false there.
export const IS_QUEST_APP = params.get('app') === 'quest';

export const IS_APP = (typeof location !== 'undefined' && location.protocol === 'oss:') || (params.has('app') && !IS_QUEST_APP);

// 'ios' (iPhone and iPad) or 'mac', from the shell's ?app= or the device.
export const APP_PLATFORM = !IS_APP ? null
  : (params.get('app') === 'mac' || params.get('app') === 'ios') ? params.get('app')
  : (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints === 0 ? 'mac' : 'ios');

if (IS_APP && typeof document !== 'undefined') {
  document.documentElement.classList.add('app-mode', `app-${APP_PLATFORM}`);
}
if (IS_QUEST_APP && typeof document !== 'undefined') document.documentElement.classList.add('quest-app');

// The live site, for links that leave the app (they open in the system
// browser: the shell sends every navigation off oss://app/ there).
export const SITE_ORIGIN = 'https://3dsolarsystem.online';
